<div echarts [options]="donutChartOptions"
     [style.width.%]="80"
     [style.height.%]="80"
     (chartInit)="onChartInit($event)"
     (chartClick)="clickEvent.emit($event)">
</div>
